module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/MATTRZ_CX_ZERO_full_red-91429e1061a84915a2a3477bd21e5070.svg";